<template>
<main-content>
<kt-panel>
    <kt-panel-body id="sheba_number_repeater">
        <div v-if="has_failed_to_sync_sheba_numbers" class="bg-danger text-white pt-2 rounded mb-4">
            <div class="mb-2 px-4">{{ $t('validation.failed_to_sync_sheba_numbers_error') }}</div>
            <ul>
                <li v-for="(sheba_number, index) in failed_to_sync_sheba_numbers" :key="index" v-text="sheba_number"></li>
            </ul>
        </div>
        <kt-form-section data-repeater-list="sheba_numbers">
            <kt-form-group hor data-repeater-item :style="{display: 'none'}">
                <div class="kt-input-icon kt-input-icon--left col-12 col-sm-9 col-lg-10">
                    <kt-row>
                        <kt-col lg="9" md="9" sm="12" xs="12">
                            <kt-form-group>
                                <kt-form-label class="ml-2">
                                    {{ $t('panel.profile.bankAccount.shebaNumber') }}
                                </kt-form-label>
                                <kt-input-group class="" id="sheba_number">
                                    <kt-form-control onkeyup="checkSheba(event)" dir="ltr" data-id="0"
                                                     name="inner-text-input-sheba" aria-describedby="national_code-error">
                                    </kt-form-control>
                                    <kt-input-group-append>
                                        <kt-input-group-text>IR</kt-input-group-text>
                                    </kt-input-group-append>
                                </kt-input-group>
                            </kt-form-group>
                        </kt-col>
                    </kt-row>
                </div>
                <div class="col-12 col-sm-3 col-lg-2 mb-lg-5 pl-lg-3 pr-lg-3 mb-md-5 pl-md-5 pr-md-5 mb-sm-5 mt-auto mb-auto">
                    <kt-form-group>
                        <a data-repeater-delete class="w-100 p-2 pt-3 btn-sm h-100 btn btn-label-danger btn-bold float-right">
                            <i class="la la-trash-o"></i>
                            {{ $t('btn.delete') }}
                        </a>
                    </kt-form-group>
                </div>
            </kt-form-group>
            <div id="sheba_page"></div>
            <kt-form-group hor data-repeater-item v-for="bankAccount in sheba_numbers" v-bind:key="bankAccount.id">
                <div class="kt-input-icon kt-input-icon--left col-12 col-sm-9 col-lg-10">
                    <kt-row>
                        <kt-col lg="9" md="9" sm="12" xs="12">
                            <kt-form-group>
                                <kt-form-label>
                                    {{ $t('panel.profile.bankAccount.shebaNumber') }}
                                </kt-form-label>
                                <kt-input-group class="" id="sheba_number">
                                    <kt-form-control onkeyup="checkSheba(event)" dir="ltr" name="inner-text-input-sheba"
                                                     aria-describedby="national_code-error" :data-id="bankAccount.id"
                                                     v-model="bankAccount.number"></kt-form-control>
                                    <kt-input-group-append>
                                        <kt-input-group-text>IR</kt-input-group-text>
                                    </kt-input-group-append>
                                </kt-input-group>
                            </kt-form-group>
                        </kt-col>
                    </kt-row>
                </div>
                <div class="col-12 col-sm-3 col-lg-2 mb-lg-5 pl-lg-3 pr-lg-3 mb-md-5 pl-md-5 pr-md-5 mb-sm-5 mt-auto mb-auto">
                    <kt-form-group>
                        <a @click="deleteItem(bankAccount)" class="w-100 h-100 p-2 pt-3 btn-sm btn btn-label-danger btn-bold float-right my-2" :id="`delete_sheba_${bankAccount.id}`">
                            <i class="la la-trash-o"></i>
                            {{ $t('btn.delete') }}
                        </a>
                    </kt-form-group>
                    <kt-form-group v-if="bankAccount.id === ''">
                        <a @click="createNewSheba(bankAccount)" class="w-100 h-100 p-2 pt-3 btn-sm btn btn-label-success btn-bold float-right" :id="`create_sheba_${bankAccount.id}`">
                            <i class="la la-send-o"></i>
                            {{ $t('btn.added') }}
                        </a>
                    </kt-form-group>
                    <kt-form-group v-else>
                        <a @click="updateSheba(bankAccount)" class="w-100 h-100 p-2 pt-3 btn-sm btn btn-label-primary btn-bold float-right" :id="`update_sheba_${bankAccount.id}`">
                            <i class="la la-pencil-square"></i>
                            {{ $t('btn.edit') }}
                        </a>
                    </kt-form-group>
                </div>
            </kt-form-group>
        </kt-form-section>
        
        <kt-form-group hor>
            <a @click="addSheba()" class="btn btn-bold btn-sm btn-label-brand">
                <i class="la la-plus"></i> {{ $t('btn.add') }}
            </a>
        </kt-form-group>

    </kt-panel-body>
</kt-panel>
</main-content>
</template>

<script>
import mainContent from './Base'
import $ from 'jquery'
import { mapGetters } from 'vuex'
import Inputmask from 'inputmask'
import IranSheba from 'iran-sheba'
import {cardNumber} from '@/constants/cardNumber'
import { KTApp } from '@/plugins/core/app'
import toastr from 'toastr'
import { i18n } from "@/plugins/i18n";

window.checkSheba = function(e) {
    const value = $(e.target).prop('value')
    const bank  = IranSheba.recognize('IR'+value.split('-').join(''))
    if(bank) {
        new Promise((resolve, reject) => {
            let elem = document.getElementById($(e.target).prop('name')+'-icon')
            if(elem) {
                elem.parentNode.removeChild(elem)
            }

            resolve()
        }).then(() => {
            const input_el = '<span id="'+$(e.target).prop('name')+'-icon" class="kt-input-icon__icon kt-input-icon__icon--left w-auto px-3">'
                + '<span class="font-weight-bold text-primary">'+bank.persianName+'</span>'
                + '</span>'
            
            $(e.target).closest('.kt-input-icon').append(input_el)
        })
    }else {
        let elem = document.getElementById($(e.target).prop('name')+'-icon')
        if(elem) {
            elem.parentNode.removeChild(elem)
        }
    }
}

window.checkCardNumber = function(e) {
    const value = $(e.target).prop('value')
    const bankCode = value.split('-').join('').substr(0, 6)
    if (cardNumber.hasOwnProperty(bankCode)) {
        new Promise((resolve, reject) => {
            let elem = document.getElementById($(e.target).prop('name')+'-icon')
            if(elem) {
                elem.parentNode.removeChild(elem)
            }

            resolve()
        }).then(() => {
            const input_el = '<span id="'+$(e.target).prop('name')+'-icon" class="kt-input-icon__icon kt-input-icon__icon--left w-auto px-3">'
                + '<span class="font-weight-bold text-primary">'+cardNumber[bankCode]+'</span>'
                + '</span>'
            $(e.target).closest('.kt-input-icon').append(input_el)
        })
    } else {
        let elem = document.getElementById($(e.target).prop('name')+'-icon')
        if(elem) {
            elem.parentNode.removeChild(elem)
        }
    }
}

export default {
    components: {
        'main-content': mainContent
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
            vm.$store.dispatch('user/fetchCurrent')
            vm.$store.dispatch('shebaNumber/fetch')
        })
    },
    data() {
        return {
            has_failed_to_sync_sheba_numbers: false,
            failed_to_sync_sheba_numbers: null,
        }
    },
    computed: {
        ...mapGetters('shebaNumber', [
            'sheba_numbers', 'bankAccounts'
        ]),
        toastr() {
            toastr.options = {
             closeButton: true,
             positionClass: "toast-bottom-center",
             preventDuplicates: false,
             rtl: false
          }

         return toastr
        }
    },
    mounted() {
        this.IMask()
    },
    methods: {
        IMask(){
            setTimeout(() => {
                Inputmask("9999-9999-9999-9999-9999-9999").mask(document.querySelectorAll('#sheba_number input'))
                Inputmask("9999-9999-9999-9999").mask(document.querySelectorAll('#card_number input'))
            }, 1000);
        },
        deleteItem(bankAccount){

            let deleteBtn = $(`#delete_sheba_${bankAccount.id}`)

            KTApp.progress(deleteBtn)

            if(bankAccount.id !== ''){
                    this.$store.dispatch('shebaNumber/deleteShebaNumber',bankAccount.id).then((response) => {
                    this.toastr.success(response.data.message)
                    this.$store.dispatch('shebaNumber/fetch')
                    this.IMask()
                    KTApp.unprogress(deleteBtn)
                }).catch(({response}) => {
                    KTApp.unprogress(deleteBtn)
                    this.toastr.error(response.data.message)
                })
            }else {
                const index = this.sheba_numbers.indexOf(bankAccount);
                this.sheba_numbers.splice(index, 1);
                KTApp.unprogress(deleteBtn)
            }

        },
        addSheba(){

            this.sheba_numbers.push({ id: '' , number: '' })
            this.IMask()

        },
        createNewSheba(bankAccount){
            let createBtn = $(`#create_sheba_${bankAccount.id}`)

            KTApp.progress(createBtn);

            const sheba = 'IR'+bankAccount.number.split('-').join('')
            if(!IranSheba.isValid(sheba)) {
                let el = $("#sheba_page")
                this.showMsg(el, "danger", i18n.t('validation.invalid_sheba_number'))
                KTApp.unprogress(createBtn);
                return
            }

            this.$store.dispatch('shebaNumber/createSheba',{sheba_number: bankAccount.number}).then((response) => {
                this.toastr.success(response.data.message)
                this.$store.dispatch('shebaNumber/fetch')
                this.IMask()
                KTApp.unprogress(createBtn)
            }).catch(({response}) => {
                KTApp.unprogress(createBtn)
                this.toastr.error(response.data.message)
            })

        },
        updateSheba(bankAccount){

             let updateBtn = $(`#update_sheba_${bankAccount.id}`)

             KTApp.progress(updateBtn) 

             const sheba = bankAccount.number.split('-').join('')
             if(!IranSheba.isValid(sheba)) {
                let el = $("#sheba_page")
                this.showMsg(el, "danger", i18n.t('validation.invalid_sheba_number'))
                this.$store.dispatch('shebaNumber/fetch')
                KTApp.unprogress(updateBtn) 
                return
            }
            this.$store.dispatch('shebaNumber/updateSheba',bankAccount).then((response) => {
                this.toastr.success(response.data.message)
                this.$store.dispatch('shebaNumber/fetch')
                this.IMask()
                KTApp.unprogress(updateBtn) 
            }).catch(({response}) => {
                KTApp.unprogress(updateBtn) 
                this.toastr.error(response.data.message)
            })
        },
    }
}
</script>

<style scoped>

</style>